import { addElevationBorder } from './helpers';

export const muiPaper = {
  styleOverrides: addElevationBorder({}),
};
